import React from 'react';
import { useTranslation } from 'react-i18next';
import ClientActionCard from './ClientActionCard';

const BusinessFieldActionCard = ({ 
    client, 
    businessFieldConfigs, 
    direction, 
    onItemClick,
    navigationFunctions 
}) => {
    const { t } = useTranslation();

    // If no client, don't render anything
    if (!client) {
        return null;
    }

    // Find configurations:
    // 1. Configs for all clients (businessFieldValue === null)
    // 2. Configs matching this client's business field
    const allClientsConfigs = businessFieldConfigs.filter(
        config => config.businessFieldValue === null || config.businessFieldValue === undefined
    );
    
    const businessFieldConfig = client.businessField !== undefined && client.businessField !== null
        ? businessFieldConfigs.find(
        config => config.businessFieldValue === client.businessField
          )
        : null;

    // Combine all configs to render
    const configsToRender = [...allClientsConfigs];
    if (businessFieldConfig) {
        configsToRender.push(businessFieldConfig);
    }

    // If no configurations found, don't render anything
    if (configsToRender.length === 0) {
        return null;
    }

    // Render all matching action cards
    return (
        <>
            {configsToRender.map((config, index) => {
                const navigationFunction = navigationFunctions[config.navigationFunctionKey];
                const typeKey = config.titleKey || 'AuditReports';
                const iconNode =
                    typeof config.icon === 'function'
                        ? React.createElement(config.icon)
                        : config.icon;

                return (
                    <ClientActionCard
                        key={index}
                        icon={iconNode}
                        title={t(config.titleKey)}
                        items={config.items}
                        accent={config.accent || 'blue'}
                        directClick={config.directClick || false}
                        onDirectClick={
                            navigationFunction ? () => navigationFunction(typeKey) : null
                        }
                    />
                );
            })}
        </>
    );
};

export default BusinessFieldActionCard; 